
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function NavbarLinks() {
  const { isAdmin, isAuthenticated } = useAuth();
  
  return (
    <div className="hidden md:flex items-center space-x-4">
      <Button asChild variant="ghost" className="flex items-center">
        <Link to="/">
          <Home className="mr-2 h-4 w-4" />
          ΑΡΧΙΚΗ
        </Link>
      </Button>
      
      {isAdmin && (
        <Button asChild variant="ghost" className="flex items-center">
          <Link to="/admin">
            <ShieldAlert className="mr-2 h-4 w-4" />
            ΔΙΑΧΕΙΡΙΣΗ
          </Link>
        </Button>
      )}
    </div>
  );
}
